import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";
import { queries } from "../queries";
import { postClassification } from "../api/generated/wrappers/backdata";
import { postManufacturer } from "../api/generated/wrappers/backdata";
export const useBasicInfo = () => {
    const { data: basicInfos, refetch: refetchBasicInfo } = useQuery(queries.basicInfo.all());
    const { data: projectInfos, refetch: refetchProject } = useQuery(queries.project.all());
    const { data: departmentInfos } = useQuery(queries.department.all());
    const { data: positionInfos } = useQuery(queries.position.all());
    const classifications = computed(() => {
        return basicInfos.value?.classifications || [];
    });
    const manufacturers = computed(() => {
        return basicInfos.value?.manufacturers || [];
    });
    const spots = computed(() => {
        return basicInfos.value?.spots || [];
    });
    const projectCodes = computed(() => {
        return projectInfos.value || [];
    });
    const departments = computed(() => {
        return departmentInfos.value || [];
    });
    const positions = computed(() => {
        return positionInfos.value || [];
    });
    // string[] 리스트 형식으로 변환
    const classificationList = computed(() => {
        return classifications.value.map((item) => item.classification);
    });
    const manufacturerList = computed(() => {
        return manufacturers.value.map((item) => item.manufacturer);
    });
    const spotList = computed(() => {
        return spots.value
            .filter((item) => item.spot !== null)
            .map((item) => item.spot);
    });
    const projectCodeList = computed(() => {
        return projectCodes.value.map((item) => item.projectCode);
    });
    const departmentList = computed(() => {
        return departments.value.map((item) => item.departmentName);
    });
    const positionList = computed(() => {
        return positions.value.map((item) => item.positionName);
    });
    const getSpotId = (spot) => {
        return spots.value.find((item) => item.spot === spot)?.id;
    };
    const getClassificationId = (classification) => {
        return classifications.value.find((item) => item.classification === classification)?.id;
    };
    const getManufacturerId = (manufacturer) => {
        return manufacturers.value.find((item) => item.manufacturer === manufacturer)?.id;
    };
    const getProjectId = (projectCode) => {
        return projectCodes.value.find((item) => item.projectCode === projectCode)
            ?.id;
    };
    const getDepartmentId = (department) => {
        return departments.value.find((item) => item.departmentName === department)
            ?.id;
    };
    const getPositionId = (position) => {
        return positions.value.find((item) => item.positionName === position)?.id;
    };
    const getOrCreateClassificationId = async (classification) => {
        const existing = getClassificationId(classification);
        if (existing)
            return existing;
        const created = await postClassification({ classification });
        await refetchBasicInfo();
        return created.id;
    };
    const getOrCreateManufacturerId = async (manufacturer) => {
        const existing = getManufacturerId(manufacturer);
        if (existing)
            return existing;
        const created = await postManufacturer({ manufacturer });
        await refetchBasicInfo();
        return created.id;
    };
    const applyBasicInfo = (userInput) => {
        return userInput.map((item) => {
            if (item.type === "auto" || item.type === "combo") {
                if (item.key === "classification") {
                    return { ...item, list: classificationList.value };
                }
                if (item.key === "manufacturer") {
                    return { ...item, list: manufacturerList.value };
                }
                if (item.key === "spot") {
                    return { ...item, list: spotList.value };
                }
                if (item.key === "projectCode") {
                    return { ...item, list: projectCodeList.value };
                }
                if (item.key === "department") {
                    return { ...item, list: departmentList.value };
                }
                if (item.key === "position") {
                    return { ...item, list: positionList.value };
                }
            }
            return item;
        });
    };
    return {
        basicInfos,
        projectInfos,
        classifications,
        manufacturers,
        spots,
        projectCodes,
        classificationList,
        manufacturerList,
        spotList,
        projectCodeList,
        applyBasicInfo,
        refetchBasicInfo,
        refetchProject,
        getSpotId,
        getClassificationId,
        getManufacturerId,
        getProjectId,
        getDepartmentId,
        getPositionId,
        getOrCreateClassificationId,
        getOrCreateManufacturerId,
    };
};
